'use strict';

import * as _ from 'lodash';
import moment from 'moment';

const angular = require('angular');
const uiRouter = require('angular-ui-router');
import uiBootstrap from 'angular-ui-bootstrap';

import routes from './application.routes';
import { EditOAuthController, AddOAuthController, DeleteOauthController, ShowSecretController, ConfirmDeleteAppController, ShareWithUsersController } from './application.modals';


export class AppComponent {
  $onInit() {
    const that = this;

    this.$http.get(`/api/applications/${this.$stateParams.id}`).then(res => { 
      that.$scope.app = res.data;      
    });
  }

  constructor($http, $scope, $state, $stateParams, $uibModal) {
    this.$http = $http;
    this.$scope = $scope;
    this.$stateParams = $stateParams;        

    $scope.$state = $state;
    $scope.$stateParams = $stateParams;        

    $scope.formatDate = date => moment(date).format('MMM Do YYYY');
    $scope.getCsv = data => _.join(data, ', ');  
    
    $scope.canShare = () => $scope.app && $scope.app.usersToShare && $scope.app.usersToShare.length > 0;

    $scope.addUserToShare = () => {
      const modalInstance = $uibModal.open({                      
        template: require('./modals/application.share.html'),
        controller: ShareWithUsersController,
        animation: true,
        controllerAs: '$ctrl',
        keyboard: true,
        size: 'md',
        resolve: {
          app: $scope.app
        }
      });

      modalInstance.result.then(app => {
        if(app) {
          $scope.app = app;
        }
      });
    };

    $scope.deleteOauth = oauth => {
      const modalInstance = $uibModal.open({                      
        template: require('./modals/application.oauth.delete.confirm.html'),
        controller: DeleteOauthController,
        animation: true,
        controllerAs: '$ctrl',
        keyboard: true,
        size: 'md',
        resolve: {
          oauth: oauth
        }
      });

      modalInstance.result.then(resultOAuth => {
        if(resultOAuth) {
          $scope.app.oauth = _.filter($scope.app.oauth, oa => oa.id !== resultOAuth.id);

          console.log('OAuth has been removed');
        }
      });
    };

    $scope.showSecret = oauth => {
      const modalInstance = $uibModal.open({                      
        template: require('./modals/application.viewSecret.html'),
        controller: ShowSecretController,
        animation: true,
        controllerAs: '$ctrl',
        keyboard: true,
        size: 'md',
        resolve: {
          oauth: oauth
        }
      });

      modalInstance.result.then(resultOAuth => {
        for(let i = 0; i < $scope.app.oauth.length; i++){
          if($scope.app.oauth[i].id === resultOAuth.id) {
            $scope.app.oauth[i].corsOrigins = resultOAuth.corsOrigins;
            $scope.app.oauth[i].redirectUrls = resultOAuth.redirectUrls;              
            $scope.app.oauth[i].secret = resultOAuth.secret;
            break;
          }
        }
      });
    };

    $scope.deleteApp = () => {
      const modalInstance = $uibModal.open({                      
        template: require('./modals/application.delete.confirm.html'),
        controller: ConfirmDeleteAppController,
        animation: true,
        controllerAs: '$ctrl',
        keyboard: true,
        size: 'md',
        resolve: {
          app: $scope.app
        }
      });
    };

    $scope.generateOAuth = () => {
      const modalInstance = $uibModal.open({                      
        template: require('./modals/application.oauth.edit.html'),
        controller: AddOAuthController,
        animation: true,
        controllerAs: '$ctrl',
        keyboard: true,
        size: 'lg',
        resolve: {
          app: $scope.app
        }       
      });

      modalInstance.result.then(resultOAuth => {
        if(resultOAuth) {
          $scope.app.oauth.push(resultOAuth);
        }
      });
    };

    $scope.editOAuth = oauth => {
      const modalInstance = $uibModal.open({                      
        template: require('./modals/application.oauth.edit.html'),
        controller: EditOAuthController,
        animation: true,
        controllerAs: '$ctrl',
        keyboard: true,
        size: 'lg',
        resolve: {
          oauth: oauth
        }       
      });

      modalInstance.result.then(resultOAuth => {
        if(resultOAuth) {
          for(let i = 0; i < $scope.app.oauth.length; i++){
            if($scope.app.oauth[i].id === resultOAuth.id) {
              $scope.app.oauth[i].corsOrigins = resultOAuth.corsOrigins;
              $scope.app.oauth[i].redirectUrls = resultOAuth.redirectUrls;              
              $scope.app.oauth[i].secret = resultOAuth.secret;
              break;
            }
          }
        }
      });
    };
  }
}

AppComponent.$inject = ['$http', '$scope', '$state', '$stateParams', '$uibModal'];

export default angular.module('syncplicityLoginApp.application', [uiRouter])
  .config(routes)
  .component('application', {
    template: require('./application.html'),
    controller: AppComponent,
    controllerAs: 'appCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/application/application.component.js